import { LOCAL_STORAGE_VAR } from '../../constants/Common';

const StorageKey = `${LOCAL_STORAGE_VAR}-VisitedDiamonds`;
export const VisitedFieldsInitialState = (() => {
  try {
    const rawList = localStorage.getItem(StorageKey);
    if (!rawList.constructor) return [];
    if (rawList.constructor.name !== 'String') return [];

    const parsedList = JSON.parse(rawList);
    if (!parsedList.constructor) return [];
    if (parsedList.constructor.name !== 'Array') return [];

    return parsedList;
  } catch (e) {
    return [];
  }
})();

export const VisitedFieldsActionTypes = {
  ADD_FIELD: '@visited-fields/add-field',
  RESET: '@visited-fields/reset',
};

export const VisitedFieldsActions = {
  addField: (id) => ({ type: VisitedFieldsActionTypes.ADD_FIELD, data: id }),
  reset: () => ({ type: VisitedFieldsActionTypes.RESET }),
};

export default function VisitedFields(state = VisitedFieldsInitialState, { type, data }) {
  switch (type) {
    case VisitedFieldsActionTypes.ADD_FIELD: {
      const newState = [...state, data];
      localStorage.setItem(StorageKey, JSON.stringify(newState));
      return newState;
    }

    case VisitedFieldsActionTypes.RESET: {
      localStorage.removeItem(StorageKey);
      return [];
    }

    default:
      return state;
  }
}
